import CryptoJS from 'crypto-js'
import { ecommerce } from '../config';

const arrayBufferToBase64 = (buffer, type) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return `data:${type};base64,${window.btoa(binary)}`;
}


const encryptData = (body) => { // async
  const encryptionSecretKey = ecommerce.ENCRYPTION_SECRET_KEY

  const key = CryptoJS.enc.Utf8.parse(encryptionSecretKey);
  const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

  // Convertir el cuerpo del mensaje a un string JSON y luego a bytes
  const jsonString = JSON.stringify(body);

  // Encriptar con AES-256-CBC
  const encrypted = CryptoJS.AES.encrypt(jsonString, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });

  // Devuelve el texto cifrado en formato hexadecimal
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

const decryptData = (encryptedHex) => {
  const encryptionSecretKey = ecommerce.ENCRYPTION_SECRET_KEY
  const key = CryptoJS.enc.Utf8.parse(encryptionSecretKey);
  const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

  // Convertir el texto cifrado de hex a un formato que pueda descifrar
  const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted);

  // Desencriptar con AES-256-CBC
  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  // Convertir de bytes a string JSON y luego a objeto
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
};



export default {
  arrayBufferToBase64,
  encryptData,
  decryptData
}